<template>
  <div data-test-id="consumer-header-style-editor-form">
    <div
      class="q-pa-md"
    >
      <div
        class="text-h5 q-mb-lg"
      >
        Header
      </div>
      <div
        class="row items-start"
      >
        <model-form-select
          :model="currentSite"
          field="consumerConfig.headerType"
          :class="inlineLayout ? 'col-6' : 'full-width'"
          label="Header Type"
          value-type="String"
          :options="$mh.asOptions(HEADER_TYPES.ALL)"
          dense
          map-options
          emit-value
        />
      </div>
      <div
        class="row q-mb-lg items-start"
        :class="inlineLayout ? 'q-gutter-y-md' : 'column q-gutter-sm'"
      >
        <model-form-checkbox
          :model="currentSite"
          field="consumerConfig.showSiteSelectorOnNavigations"
          :class="inlineLayout ? 'col-3' : 'col'"
          label="Show Site Location/Selector"
          value-type="Boolean"
        />
        <template v-if="currentSite.consumerConfig.headerType !== HEADER_TYPES.DEFAULT">
          <model-form-checkbox
            :model="currentSite"
            field="consumerConfig.headerShowSocialIcons"
            :class="inlineLayout ? 'col-3' : 'col'"
            label="Show Social Media Icons"
            value-type="Boolean"
          />

          <model-form-checkbox
            :model="currentSite"
            field="consumerConfig.headerLogoCentered"
            :class="inlineLayout ? 'col-3' : 'col'"
            label="Logo Centered"
            value-type="Boolean"
          />
          <model-form-checkbox
            :model="currentSite"
            field="consumerConfig.headerFullWidth"
            :class="inlineLayout ? 'col-3' : 'col'"
            label="Full Width"
            value-type="Boolean"
          />
          <model-form-checkbox
            :model="currentSite"
            field="consumerConfig.stickyHeader"
            :class="inlineLayout ? 'col-3' : 'col'"
            label="Fixed Position"
            value-type="Boolean"
          />
          <model-form-checkbox
            :model="currentSite"
            field="consumerConfig.headerBgTransparent"
            :class="inlineLayout ? 'col-3' : 'col'"
            label="Transparent Background"
            value-type="Boolean"
          />
          <model-form-checkbox
            v-if="currentSite.consumerConfig.headerType === HEADER_TYPES.STANDARD"
            :model="currentSite"
            field="consumerConfig.headerStackedText"
            :class="inlineLayout ? 'col-3' : 'col'"
            label="Stack Navigation Text"
            value-type="Boolean"
          />
          <model-form-select
            :model="currentSite"
            field="consumerConfig.headerButtonHoverStyle"
            :class="inlineLayout ? 'col-6' : 'full-width'"
            label="Hover Style"
            value-type="String"
            :options="$mh.asOptions(HEADER_HOVER_TYPES.ALL)"
            dense
            map-options
            emit-value
          />
        </template>
      </div>
    </div>
    <slot name="action-footer" />
  </div>
</template>

<script>
import { HEADER_HOVER_TYPES, HEADER_TYPES } from 'src/models/site/Site'

export default {
  name: 'ConsumerHeaderStyleEditor',
  props: {
    currentSite: {
      type: Object,
      required: true
    },
    inlineLayout: {
      type: Boolean,
      default: false
    },
    showSiteSelectorConfiguration: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'currentSite.consumerConfig.headerType' (val) {
      if (val === HEADER_TYPES.DEFAULT) {
        this.currentSite.consumerConfig.headerShowSocialIcons = false
        this.currentSite.consumerConfig.headerLogoCentered = false
        this.currentSite.consumerConfig.headerFullWidth = false
        this.currentSite.consumerConfig.stickyHeader = true
        this.currentSite.consumerConfig.headerBgTransparent = false
        this.currentSite.consumerConfig.headerStackedText = false
        this.currentSite.consumerConfig.headerButtonHoverStyle = HEADER_HOVER_TYPES.DEFAULT
      }
    }
  },
  created () {
    _.extend(this, { HEADER_TYPES, HEADER_HOVER_TYPES })
  },
  methods: {
    async saveSite () {
      await this.currentSite.save()
    }
  }
}

</script>
